import './App.scss';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Header from './Layouts/Header/Header';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import AboutUs from './Pages/AboutUs/AboutUs';
// import OurPlatForm from './Pages/OurPlatForm/OurPlatForm';
import Team from './Pages/Team/Team';
import News from './Pages/News/News';
import Careers from './Pages/Careers/Careers';
import Contact from './Pages/Contact/Contact';
import Product from './Pages/OurPlatForm/Product';
import LaboratoryServices from './Pages/OurPlatForm/LaboratoryServices';
import OurApproach from './Pages/OurPlatForm/OurApproach';
import { useEffect, useState } from 'react';
import Footer from './Layouts/Footer/Footer';
import { ToastContainer } from 'react-toastify';  
import 'react-toastify/dist/ReactToastify.css';  
import MobileViewOurApproach from './Pages/OurPlatForm/MobileViewOurPlatForm/MobileViewOurApproach';
import LaboratoryServiceMobile from './Pages/OurPlatForm/LaboratoryServiceMobile';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions/TermsConditions';
import Event from './Pages/Events/Event';
import EventInsidePitsburg from './Pages/Events/EventInsidePitsburg';
import EventInsidePitMd from './Pages/Events/EventInsidePitMd';
import Technology from './Pages/Technology/Technology';
import Products from './Pages/Products/Products';

 
function App() {
  const ScrollToTop = () => {
    const location = useLocation();
   
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
   
    return null;
  };


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };
  
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [window.innerWidth]);


    console.log("isMobile",isMobile);
    
  return (
    <div className='w-100 main-content'>
      <Router>
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/about-us" element={<AboutUs />} />
          {/* <Route path="/our-platform" element={<OurPlatForm />} /> */}
          <Route path="/team" element={<Team />} />
          <Route path="/news" element={<News />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/product" element={<Product />} />
          <Route path="/event" element={<Event />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/products" element={<Products />} />
          <Route path="/event/event-pitsburg" element={<EventInsidePitsburg />} />
          <Route path="/event/event-pitmdplus" element={<EventInsidePitMd />} />

          <Route path="/LaboratoryServices" element={ isMobile === false ? <LaboratoryServices/>:<LaboratoryServiceMobile/>} />
          <Route path="/our-approach" element={ isMobile=== false ? <OurApproach/>:<MobileViewOurApproach/>} />
          {/* Default route can be added */}
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
          <Route path="/" element={<AboutUs />} />
        </Routes>
        <Footer/>
        <ToastContainer /> 
      </Router>
    </div>
 

  );
}
 
export default App;